import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import {
  IImportSegmentsViewModelApiProxy,
  ImportSegmentsViewModel,
} from "./import-segments-view-model";
import * as Papa from "papaparse";
import { MediaRepository } from "../../domain/media-repository";
import {
  UpsertSegmnetEntry,
  UpsertSegmnetsResultEntry,
} from "../../domain/media";

@Component({
  selector: "evrideo-import-segments-csv",
  templateUrl: "./import-segments-csv.component.html",
  styleUrls: ["./import-segments-csv.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportSegmentsCsvComponent implements OnInit {
  vm: ImportSegmentsViewModel;
  constructor(
    private _mediaRepository: MediaRepository,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    const $this = this;
    this.vm = new ImportSegmentsViewModel(<IImportSegmentsViewModelApiProxy>{
      fileToRowObjectsArray(file: File): Promise<Array<object>> {
        return new Promise((resolve, reject) => {
          Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            error: (e) => reject(e),
            complete: (result) => resolve(result.data),
          });
        });
      },
      upsertSegments(
        segments: Array<UpsertSegmnetEntry>,
      ): Promise<Array<UpsertSegmnetsResultEntry>> {
        return $this._mediaRepository.upsertSegments(segments);
      },
      updateUI() {
        $this._changeDetectorRef.detectChanges();
        $this._changeDetectorRef.markForCheck();
      },
    });
  }
}
